import { useEffect } from "react";
import useTranslator from "../../../hooks/useTranslator";
import { useLocation, useNavigate } from "react-router-dom";
import { haveValue } from "../../../helper/common";
import { useCookies } from "react-cookie";

const UserTypeCheckbox = ({ value, checked, onChange, imgSrc, label }) => (
  <div className="uilabel">
    <input
      className="form-check-input"
      type="checkbox"
      value={value}
      checked={checked}
      onChange={onChange}
      id={label}
    />
    <label className="form-check-label img-diff" htmlFor={label}>
      <div className="imgbar">
        <img src={imgSrc} alt="icon" />
      </div>
      <div className="contentbar">
        <h5>{label}</h5>
      </div>
    </label>
  </div>
);

const SelectUserTypeScreen = ({
  checkedTenant,
  checkedLandlord,
  handleUsertype,
  setCurrentScreen,
  setIsGuarantor,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const [cookies] = useCookies(["sharedProfileLink"]);

  useEffect(() => {
    if (haveValue(cookies.gurantorFor)) {
      guarantorClicked();
      navigate(`/auth`);
    } else {
      setIsGuarantor(false);
    }
  }, [cookies]);
  const guarantorClicked = () => {
    const temp = {
      target: {
        value: "tenant",
      },
    };
    handleUsertype(temp);
    setIsGuarantor(true);
    setCurrentScreen("selectUserEmail");
  };

  return (
    <>
      <div className="checkboxbar">
        <div className="inlinecheckbar">
          <UserTypeCheckbox
            value="tenant"
            checked={checkedTenant}
            onChange={handleUsertype}
            imgSrc="/images/t1.svg"
            label={_t("tenant")}
          />
          <UserTypeCheckbox
            value="landlord"
            checked={checkedLandlord}
            onChange={handleUsertype}
            imgSrc="/images/t2.svg"
            label={_t("landlord")}
          />
          <a
            href={undefined}
            className="btnlink text-decoration-underline"
            onClick={guarantorClicked}
            style={{ fontSize: "1.389vw" }}
          >
            {_t("loginAsAGuarantor", "On login screen for guarantor")}
          </a>
        </div>
      </div>
      <div className="btngroup">
        <button
          type="button"
          className="btn btnorange"
          onClick={() => setCurrentScreen("selectUserEmail")}
        >
          {" "}
          {_t("continue")}
        </button>
      </div>
    </>
  );
};

export default SelectUserTypeScreen;
